"use client";
import { useForm, zodResolver } from "@mantine/form";
import { z } from "zod";
import BackButton from "../BackButton";
import { Autocomplete, Checkbox, Group, NativeSelect, Radio } from "@mantine/core";
import { TextInput } from "../Inputs/TextInput";
import { countries_list_german } from "@/utils";
import Button from "../Cards/Button";
import { ButtonDark } from "@/stories/Button.stories";
import ErrorModal from "../ErrorModal";
import { useState } from "react";
import InfoModal from "../Modal";
import Text from "../Text/Text";

export default function AnmeldungFormularLayout({
    sendEmail,
}: {
    sendEmail: (subject: string, data: object) => Promise<void>;
}) {
    const [openModal, setOpenModal] = useState(false);
    const [error, setError] = useState(false);
    const schema = z.object({
        email: z
            .string()
            .email()
            .refine((value) => value.length > 0, {
                message: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
            }),
        agree: z.boolean().refine((value) => value === true, {
            message: "Bitte akzeptieren Sie die AGB",
        }),
    });
    const form = useForm({
        initialValues: {
            participants: "",
            anrede: "",
            name: "",
            surname: "",
            email: "",
            address: "",
            plz: "",
            location: "",
            country: "",
            alreadyCustomer: false,
            agree: false,
        },

        validate: zodResolver(schema),
    });
    return (
        <>
            <div className="container px-3 lg:mx-auto my-40 max-w-10xl">
                <div className="flex justify-between px-1 py-5">
                    <BackButton link="/de" title="Anmeldung zum Workshop" />
                </div>
                <h1 className="text-black text-xl3 px-2 py-3 lg:px-0 lg:text-5xl font-bold  leading-7 lg:leading-14">
                    Deine Anmeldung <br />
                    zum Workshop vom <br /> 21.03. - 22.03.2025
                </h1>
                <form
                    className="space-y-3"
                    onSubmit={form.onSubmit((values) => {
                        const data = {
                            participants: values.participants,
                            anrede: values.anrede,
                            name: values.name,
                            surname: values.surname,
                            email: values.email,
                            address: values.address,
                            plz: values.plz,
                            location: values.location,
                            country: values.country,
                            alreadyCustomer: values.alreadyCustomer,
                            agree: values.agree,
                        };
                        sendEmail("Anmeldung zum Workshop", data)
                            .then(() => {
                                setOpenModal(true);
                            })
                            .catch((e) => {
                                <ErrorModal
                                    open={error}
                                    onClose={() => setError(false)}
                                />;
                            });
                        console.log(data);
                    })}
                >
                    <p className="grow shrink basis-0 text-neutral-800 lg:text-lg text-base font-bold  leading-tight">
                        Teilnehmer
                    </p>
                    <NativeSelect
                        id="participants"
                        name="participants"
                        className="w-20"
                        data={["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]}
                        {...form.getInputProps("participants")}
                    />
                    <Checkbox
                        id="alreadyCustomer"
                        name="alreadyCustomer"
                        label="Ich bin bereits Kunde"
                        className="text-xl"
                        size="md"
                        {...form.getInputProps("alreadyCustomer")}
                    />
                    {form.values.alreadyCustomer !== true && (
                        <>
                            <p className="grow shrink basis-0 text-neutral-800 lg:text-lg text-base font-bold  leading-tight">
                                Anrede
                            </p>

                            <Radio.Group
                                id="anrede"
                                name="anrede"
                                {...form.getInputProps("anrede")}
                            >
                                <Group mt="xs">
                                    <Radio label="Frau" value="frau" />
                                    <Radio label="Herr" value="herr" />
                                    <Radio label="Divers" value="divers" />
                                </Group>
                            </Radio.Group>
                        </>
                    )}
                    <TextInput
                        id="name"
                        name="name"
                        type="text"
                        label="Vorname"
                        placeholder="Hier eingeben"
                        width="lg:w-[634px] w-full"
                        {...form.getInputProps("name")}
                    />
                    <TextInput
                        id="surname"
                        name="surname"
                        type="text"
                        label="Nachname"
                        placeholder="Hier eingeben"
                        width="lg:w-[634px] w-full"
                        {...form.getInputProps("surname")}
                    />
                    <TextInput
                        id="email"
                        name="email"
                        type="email"
                        label="Deine E-Mail-Adresse"
                        placeholder="Hier eingeben"
                        width="lg:w-[634px] w-full"
                        {...form.getInputProps("email")}
                    />
                    {form.values.alreadyCustomer !== true && (
                        <>
                            <TextInput
                                id="address"
                                name="address"
                                type="text"
                                label="Adresse"
                                placeholder="Hier eingeben"
                                width="lg:w-[634px] w-full"
                                {...form.getInputProps("address")}
                            />
                            <div className="flex gap-3 justify-between">
                                <TextInput
                                    id="plz"
                                    name="plz"
                                    type="text"
                                    label="PLZ"
                                    placeholder="Hier eingeben"
                                    width="w-[170px] md:w-[310px] lg:w-[310px]"
                                    {...form.getInputProps("plz")}
                                />

                                <TextInput
                                    id="location"
                                    name="location"
                                    type="text"
                                    label="Ort"
                                    width="w-[170px] md:w-[310px] lg:w-[310px]"
                                    placeholder="Hier eingeben"
                                    {...form.getInputProps("location")}
                                />
                            </div>
                            <div>
                                <p className="grow shrink basis-0 text-neutral-800 text-base font-bold  leading-tight">
                                    Land
                                </p>
                                <Autocomplete
                                    className="border-2 border-black"
                                    id="country"
                                    name="country"
                                    placeholder="Bitte auswählen"
                                    data={countries_list_german}
                                    width="lg:w-[634px] w-full"
                                    {...form.getInputProps("country")}
                                />
                            </div>
                        </>
                    )}

                    <Checkbox
                        id="agree"
                        name="agree"
                        label="Ich bin mit den AGB einverstanden."
                        className="text-xl"
                        size="md"
                        {...form.getInputProps("agree")}
                    />
                    <Button
                        size={ButtonDark.args?.size}
                        paddings={ButtonDark.args?.paddings}
                        text="Kostenpflichtig anmelden"
                        hasIcon={ButtonDark.args?.hasIcon}
                        buttonType="submit"
                    />
                    <div className="text-black text-base font-normal  leading-tight">
                        Deine Daten werden vertraulich behandelt.
                    </div>
                </form>
                <InfoModal
                    onClose={() => setOpenModal(false)}
                    opened={openModal}
                    size="xl"
                >
                    <>
                        <Text
                            hasPretitle={false}
                            hasSubTitle={false}
                            hasText={true}
                            paddings=""
                            title="Danke für deine Nachricht!"
                            paragraphs={[
                                "Ich habe deine Anfrage erhalten. Wir senden dir in den kommenden Tagen eine E-Mail mit weiteren Informationen zum Workshop.",
                                "Liebe Grüsse",
                                "Rico Brunner",
                            ]}
                        />
                        <div className="flex py-5 justify-end">
                            <Button
                                size={ButtonDark.args?.size}
                                backgroundColor={ButtonDark.args?.backgroundColor}
                                hasIcon={ButtonDark.args?.hasIcon}
                                text="Home"
                                textColor={ButtonDark.args?.textColor}
                                textSize={ButtonDark.args?.textSize}
                                as="a"
                                href="/"
                            />
                        </div>
                    </>
                </InfoModal>
            </div>
        </>
    );
}
